import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import Http from "../../Http";
import { Insurance_API } from "../../Helper";
import {
  FaBalanceScale,
  FaChartLine,
  FaArrowDown,
  FaUndo,
  FaExchangeAlt,
  FaUsers,
} from "react-icons/fa";
import {
  FaShieldAlt,
  FaDollarSign,
  FaHome,
  FaMoneyBillWave,
  FaSmile,
  FaHandHoldingUsd,
  FaPlusCircle,
  FaClock,
} from "react-icons/fa";
import {
  FaHeart,
  FaCarCrash,
  FaStethoscope,
  FaMoneyCheckAlt,
  FaRedo,
} from "react-icons/fa";
import { ArrowRight } from "lucide-react";

function Icon({ id, open }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={2}
      stroke="currentColor"
      className={`${
        id === open ? "rotate-180" : ""
      } h-5 w-5 transition-transform`}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M19.5 8.25l-7.5 7.5-7.5-7.5"
      />
    </svg>
  );
}

const TermLifeInsuranceNew = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [insuranceData, setInsuranceData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const faqs = [
    {
      question: "What is term life insurance and how does it work?",
      answer:
        "Term life insurance is a type of life insurance policy that provides coverage for a specific period (e.g., 10, 20, or 30 years). If the policyholder passes away during the term, the insurer pays a death benefit to the nominee. If the policyholder survives the term, there is no payout unless it is a return-of-premium plan.",
    },
    {
      question:
        "What factors affect the premium of a term life insurance policy?",
      answer:
        "Premiums are calculated based on factors such as age, gender, health condition, lifestyle habits (like smoking), policy term, and the sum assured. Younger and healthier individuals usually pay lower premiums.",
    },
    {
      question: "Is a medical test mandatory for term life insurance?",
      answer:
        "Most insurers require a medical examination for policies with higher sum assured or if the applicant is older or has a pre-existing condition. However, some policies allow for no-medical exam coverage up to a certain limit, subject to terms and conditions.",
    },
    {
      question: " Can I increase my term insurance coverage later?",
      answer:
        "Yes, some term insurance plans offer the option to increase coverage at key life stages such as marriage, childbirth, or home purchase. This feature varies across insurers, so it is important to check policy terms.",
    },
    {
      question: "What happens if I miss a premium payment?",
      answer:
        "Missing a premium may lead to policy lapse. However, insurers typically offer a grace period of 15 to 30 days during which you can make the payment without losing coverage. After the grace period, reinstating the policy may require additional procedures or penalties.",
    },
    {
      question: " Can I buy term life insurance through TheFinMaster.com?",
      answer:
        "TheFinMaster.com is not a life insurance provider. We offer detailed educational content, comparison tools, and unbiased insights to help you choose the right term insurance policy. Once yo have found a suitable option, you will be redirected to the insurer’s official site for a secure application process.",
    },
    {
      question: " What is the ideal duration for a term life insurance policy?",
      answer:
        " The ideal term should typically cover you until your financial responsibilities are over—such as children's education or loan repayment. Most people choose coverage up to retirement age or a maximum of 60 to 65 years.",
    },
    {
      question: " Does term life insurance offer maturity benefits?",
      answer:
        " Pure term insurance plans do not offer maturity or survival benefits. However, some variants like return of premium (ROP) plans return the total premium paid if the policyholder survives the policy term.",
    },
    {
      question: " What is the claim settlement ratio and why is it important?",
      answer:
        "The claim settlement ratio shows the percentage of claims an insurer has settled out of total claims received. A higher ratio indicates a reliable insurer and increases your chances of a hassle-free claim process for your family.",
    },
    {
      question: " Can NRIs purchase term life insurance in India?",
      answer:
        " Yes, many Indian insurers allow NRIs to buy term plans. The process usually involves online application, documentation, and in some cases, medical tests in the country of residence or upon the next visit to India.",
    },
    {
      question: " Is there any tax benefit on term life insurance?",
      answer:
        "Yes, premiums paid for term life insurance are eligible for tax deductions under Section 80C of the Income Tax Act. Additionally, the death benefit received by the nominee is tax-free under Section 10(10D).",
    },
    {
      question: " Can I assign my term insurance policy to someone else?",
      answer:
        " Yes, you can assign a term insurance policy to a lender or individual by completing the necessary documentation. This is often done in cases like home loans or as collateral for business funding.",
    },
    {
      question: " What is a rider in term life insurance?",
      answer:
        " A rider is an add-on benefit that enhances your policy coverage. Common riders include accidental death, critical illness, and waiver of premium. They offer extra protection for a nominal additional cost.",
    },
    {
      question: "How is the sum assured decided in term insurance?",
      answer:
        " The sum assured should ideally be 10 to 15 times your annual income or enough to cover your family’s future financial needs, debts, and lifestyle expenses in your absence. Many insurers offer online calculators to help with this.",
    },
    {
      question: "Will my term insurance payout be affected if I die abroad?",
      answer:
        " No, most term plans offer global coverage, so the nominee will still receive the sum assured even if the policyholder dies outside India, provided all disclosures were honest and the policy is active.",
    },
    {
      question: " What if I outlive my term insurance policy?",
      answer:
        " In a regular term plan, no money is paid if you survive the term. However, if you’ve opted for a return of premium plan, the total premium paid (excluding taxes and charges) is returned upon maturity.",
    },
  ];
  const TerminsuranceTypes = [
    {
      title: "Level Term Insurance",
      description:
        "The most basic type, where the sum assured remains constant throughout the policy tenure, and beneficiaries receive a fixed payout in case of the policyholder’s demise.",
      icon: <FaBalanceScale className="text-4xl text-blue-600" />,
    },
    {
      title: "Increasing Term Insurance ",
      description:
        "In this plan, the coverage amount increases over time, helping policyholders keep up with inflation while maintaining financial security for their families.",
      icon: <FaChartLine className="text-4xl text-green-600" />,
    },
    {
      title: "Decreasing Term Insurance",
      description:
        " Best suited for individuals with loans or liabilities, where the sum assured decreases gradually over time, aligning with the repayment of debts like home or business loans.",
      icon: <FaArrowDown className="text-4xl text-orange-600" />,
    },
    {
      title: "Return of Premium Term Insurance",
      description:
        "Unlike pure term plans, this policy refunds the premiums paid if the policyholder survives the policy term, making it an option for those seeking a return on investment.",
      icon: <FaUndo className="text-4xl text-red-600" />,
    },
    {
      title: "Convertible Term Insurance",
      description:
        "A flexible plan that allows policyholders to convert their term insurance into a whole life or endowment plan, offering long-term coverage and potential maturity benefits.",
      icon: <FaExchangeAlt className="text-4xl text-purple-600" />,
    },
    {
      title: "Group Term Insurance",
      description:
        "Typically provided by employers, this plan covers multiple individuals under a single policy, offering basic life coverage to employees or members of an organization.",
      icon: <FaUsers className="text-4xl text-green-400" />,
    },
  ];
  const reasons = [
    {
      title: "Financial Security for Family",
      description:
        "Term life insurance ensures that your loved ones are financially protected in case of your untimely demise. The lump sum payout helps them cover daily expenses, maintain their lifestyle, and secure their future.",
      icon: <FaShieldAlt className="text-blue-600 text-3xl" />,
    },
    {
      title: "Affordable Premiums with High Coverage",
      description:
        "Compared to other life insurance plans, term insurance offers substantial coverage at low premiums, making it an affordable choice for securing financial stability.",
      icon: <FaDollarSign className="text-green-600 text-3xl" />,
    },
    {
      title: "Debt Repayment Protection",
      description:
        "If you have loans like home, car, or business loans, term insurance ensures that your family doesn’t face the burden of repaying debts in your absence.",
      icon: <FaHome className="text-orange-600 text-3xl" />,
    },
    {
      title: "Income Replacement",
      description:
        "For primary breadwinners, a term plan acts as an income replacement, ensuring that dependents do not struggle financially after the loss of the earning member.",
      icon: <FaMoneyBillWave className="text-yellow-600 text-3xl" />,
    },
    {
      title: "Peace of Mind",
      description:
        "Knowing that your family is covered in case of unforeseen circumstances provides mental peace, allowing you to focus on other aspects of life without constant financial worries.",
      icon: <FaSmile className="text-purple-600 text-3xl" />,
    },
    {
      title: "Tax Benefits",
      description:
        "Under Section 80C and Section 10(10D) of the Income Tax Act, policyholders can avail of tax benefits on premiums paid and payouts received, making term insurance a tax-efficient financial tool.",
      icon: <FaBalanceScale className="text-red-600 text-3xl" />,
    },
    {
      title: "Flexible Payout Options",
      description:
        "Many term insurance plans offer lump sum, monthly income, or a combination of both as payout options, ensuring that dependents receive financial support in a structured manner.",
      icon: <FaHandHoldingUsd className="text-teal-600 text-3xl" />,
    },
    {
      title: "Critical Illness and Disability Riders",
      description:
        "Term insurance policies can be enhanced with riders that provide additional benefits for critical illnesses, accidental death, or permanent disability, offering broader financial protection.",
      icon: <FaPlusCircle className="text-pink-600 text-3xl" />,
    },
    {
      title: "Long-Term Coverage",
      description:
        "Term plans can provide coverage for up to 80 years or more, ensuring lifelong financial security for dependents when chosen wisely.",
      icon: <FaClock className="text-indigo-600 text-3xl" />,
    },
    {
      title: "Protection Against Inflation",
      description:
        "With increasing living costs, some term plans offer the option to increase coverage over time, ensuring that the payout remains relevant despite inflation.",
      icon: <FaChartLine className="text-gray-600 text-3xl" />,
    },
  ];
  const coverageOptions = [
    {
      title: "Death Benefit",
      description:
        "Provides a lump sum payout to the nominee in case of the policyholder’s demise during the policy term, ensuring financial security for the family.",
      icon: <FaHeart className="text-red-600 text-3xl" />,
    },
    {
      title: "Accidental Death & Disability Cover",
      description:
        "Offers additional coverage in case of accidental death or permanent disability, providing financial assistance when needed the most.",
      icon: <FaCarCrash className="text-orange-600 text-3xl" />,
    },
    {
      title: "Critical & Terminal Illness Benefit",
      description:
        "Some plans offer payouts upon diagnosis of critical or terminal illnesses, helping cover medical expenses and income loss.",
      icon: <FaStethoscope className="text-blue-600 text-3xl" />,
    },
    {
      title: "Income Replacement Option",
      description:
        "Instead of a lump sum, some policies provide regular payouts to the nominee, ensuring a steady income for the family’s needs.",
      icon: <FaMoneyCheckAlt className="text-green-600 text-3xl" />,
    },
    {
      title: "Return of Premium Option",
      description:
        "Certain term plans refund the total premiums paid if the policyholder survives the policy tenure, providing financial benefits even in survival.",
      icon: <FaRedo className="text-purple-600 text-3xl" />,
    },
    {
      title: "Riders for Enhanced Coverage",
      description:
        "Additional riders like waiver of premium, hospital cash benefits, and accidental disability riders can be added for extra protection.",
      icon: <FaPlusCircle className="text-teal-600 text-3xl" />,
    },
  ];
  const points2 = [
    {
      title: " Coverage Amount (Sum Assured) ",
      description: `Choose a coverage amount that adequately secures your family's financial future, ideally 10-15 times your annual income. This ensures they can manage daily expenses, outstanding debts, and future financial goals.`,
    },
    {
      title: "Policy Tenure",
      description: ` Opt for a policy duration that covers you until your retirement age or until your financial responsibilities (like children’s education or loan repayments) are met. Longer tenures provide extended security.`,
    },
    {
      title: "Premium Affordability",
      description: `While term plans are cost-effective, ensure that the premium fits within your budget. Look for a balance between affordable premiums and sufficient coverage to avoid financial strain.`,
    },
    {
      title: "Riders & Add-Ons",
      description: `Consider additional benefits like critical illness cover, accidental death benefit, or waiver of premium riders to enhance the policy’s protection based on your needs.`,
    },
    {
      title: "Claim Settlement Ratio",
      description: `Always check the insurer’s claim settlement ratio (CSR), which reflects their reliability in settling claims. A higher CSR (above 95%) indicates better chances of claim approval for your beneficiaries.`,
    },
    {
      title: "Inflation Impact  ",
      description: `Account for future inflation when deciding the coverage amount. Opt for increasing sum assured plans to keep the policy’s value relevant over time.`,
    },
    {
      title: "Exclusions & Terms ",
      description: ` Read the policy document carefully to understand exclusions, waiting periods, and any clauses that may impact the claim process.`,
    },
    {
      title: "Online vs. Offline Purchase ",
      description: ` Buying online is often cheaper due to lower operational costs. Compare different plans online to find the best deal with maximum benefits.`,
    },
  ];
  const points3 = [
    {
      title: " Suicide Clause ",
      description: ` If the policyholder dies by suicide within the first year of policy issuance or revival, the insurer may not provide the full death benefit, only returning a portion of premiums paid.`,
    },
    {
      title: "Death Due to Hazardous Activities",
      description: `Any fatality resulting from high-risk activities such as adventure sports, racing, or skydiving may not be covered unless specified in the policy.`,
    },
    {
      title: "Pre-Existing Medical Conditions",
      description: `Death caused by undisclosed or pre-existing critical illnesses may not be covered if the insurer was not informed at the time of purchasing the policy.`,
    },
    {
      title: "Death Due to Drug or Alcohol Abuse",
      description: ` If the policyholder’s death is linked to excessive alcohol consumption, drug overdose, or substance abuse, the claim may be rejected.`,
    },
    {
      title: "Participation in Criminal or Illegal Activitie",
      description: `Death occurring while committing a crime, engaging in unlawful activities, or resisting arrest may lead to claim denial.`,
    },
    {
      title: "Death Due to War or Terrorism  ",
      description: ` Most term insurance policies exclude coverage for deaths caused by war, riots, terrorism, or civil disturbances.`,
    },
  ];
  const points1 = [
    {
      title: "Age of the Policyholder ",
      description: `Younger individuals get lower premiums since they are considered lower-risk, whereas older individuals pay higher premiums due to increased health risks.`,
    },
    {
      title: "Health & Medical History",
      description: `  Pre-existing illnesses, chronic conditions, and family medical history affect premium costs. Healthier individuals with no serious medical conditions get better rates.`,
    },
    {
      title: "Lifestyle Habits",
      description: `Smoking, alcohol consumption, or engaging in high-risk activities like adventure sports can lead to higher premiums due to increased risk of mortality.`,
    },
    {
      title: "Policy Tenure ",
      description: `Longer policy terms may result in slightly higher premiums but ensure coverage for an extended period, securing your family for a longer duration.`,
    },
    {
      title: "Sum Assured (Coverage Amount)",
      description: `Higher coverage leads to higher premiums since the insurer’s liability increases. Choosing an adequate sum insured is crucial for your family's financial security.`,
    },
    {
      title: "Occupation & Income Level ",
      description: ` Individuals working in high-risk jobs (e.g., pilots, miners, construction workers) may have higher premiums due to occupational hazards. Your income level also determines your eligibility for a specific coverage amount.`,
    },
    {
      title: "Add-on Riders ",
      description: ` Additional benefits like critical illness cover, accidental death benefit, or waiver of premium increase the overall cost of the policy.`,
    },
    {
      title: "Claim Settlement Ratio of the Insurer ",
      description: ` Opting for an insurer with a high claim settlement ratio ensures that your family faces fewer hurdles during claim processing.`,
    },
    {
      title: "Inflation & Economic Factors ",
      description: ` Future inflation impacts the purchasing power of the sum assured. Some policies offer increasing cover options to combat inflationary effects.`,
    },
    {
      title: "Premium Payment Mode",
      description: ` Paying premiums annually is often cheaper than monthly or quarterly payments, as insurers may offer discounts for annual payments.`,
    },
  ];
  const toggleAccordion = (index) => {
    if (activeIndex === index) {
      // If the clicked question is already expanded, collapse it
      setActiveIndex(null);
    } else {
      // If the clicked question is not expanded, expand it
      setActiveIndex(index);
    }
  };
  useEffect(() => {
    fetchInsuranceData();
  }, []);

  const fetchInsuranceData = async () => {
    try {
      const response = await Http.get(Insurance_API);

      // The response structure might have nested data
      // Check if response has an insurance property (like in the original fetch response)
      const data = response.insurance || response;

      // Filter the insurance data to show only Car category
      const carInsuranceData = Array.isArray(data)
        ? data.filter((insurance) => insurance.category_name === "Term Life")
        : [];

      setInsuranceData(carInsuranceData);
      setLoading(false);
    } catch (error) {
      setError("Failed to fetch insurance data");
      setLoading(false);
      console.error("Error fetching data:", error);
    }
  };

  // const fetchInsuranceData = async () => {
  //     try {
  //         console.log("Calling API with GET method...");

  //         // Use the get method from http.js and the Insurance_API constant
  //         const data = await Http(Insurance_API);
  //         // Set the insurance array from the data object
  //         setInsuranceData(data.insurance || []);
  //         setLoading(false);
  //     } catch (error) {
  //         setError('Failed to fetch insurance data');
  //         setLoading(false);
  //         console.error('Error fetching data:', error);
  //     }
  // };
  const ad2 = {
    image: "/assets/popad.png",
    link: "https://play.google.com/store/apps/details?id=com.popclub.android&pcampaignid=web_share",
    altText: "Advertisement",
  };
  return (
    <>
      <Helmet>
        <title>
          Car Insurance Online - Buy/Renew Car Insurance Policy & Save Upto 60%
        </title>
        <meta
          name="description"
          content="Car Insurance Online - Buy/Renew Car Insurance policy from Thefinmaster at best price & save upto 60%* on four wheeler insurance policy premium."
        />
        <meta
          name="keywords"
          content="auto insurance coverages, automobile insurance companies, commercial auto insurance, icici lombard motor insurance, maruti insurance online"
        />
        <link
          rel="canonical"
          href="https://thefinmaster.com/termlife_insurance"
        />
        <meta
          name="robots"
          content="max-snippet:-1, max-image-preview:standard"
        />
        <meta name="robots" content="max-video-preview:-1" />
      </Helmet>
      {/* Your existing content */}
      <nav className="text-gray-500 text-sm my-4 ml-10" aria-label="Breadcrumb">
        <ol className="list-none p-0 inline-flex">
          <li className="flex items-center">
            <Link to="/" className="text-blue-600 hover:text-blue-800 ">
              Home
            </Link>
            <svg
              className="w-4 h-4 mx-2 text-gray-500"
              fill="currentColor"
              viewBox="0 0 20 20"
            >
              <path
                fillRule="evenodd"
                d="M7.293 14.707a1 1 0 010-1.414L11.586 9 7.293 4.707a1 1 0 111.414-1.414l5 5a1 1 0 010 1.414l-5 5a1 1 0 01-1.414 0z"
                clipRule="evenodd"
              />
            </svg>
          </li>

          <li className="flex items-center">
            <span className="text-gray-500 ">Term Insurance</span>
          </li>
        </ol>
      </nav>
      <div className="w-full flex flex-col items-center">
        <div className="w-full flex justify-center">
          <div className="w-full sm:w-[95%] flex flex-col sm:flex-row justify-center items-center">
            <div className="w-full sm:w-[50%]">
              <div className="w-[90%]">
                <h1 className="text-4xl md:text-5xl font-bold mt-6 md:mt-0 md:pl-0 pl-6">
                  <span className="text-blue-600 ">
                    Secure Your Family's Financial Future
                  </span>{" "}
                  Explore Life Insurance Now!
                </h1>
                {/* <a href="#insurance_plans">
                  <button className="py-4 px-8  border rounded-full bg-blue-600 text-white shadow-lg hover:shadow-xl text-lg mt-10 font-medium">
                    See Plans
                  </button>
                </a> */}
              </div>
            </div>
            <div className="w-full sm:w-[50%]">
              <img
                className="w-full max-w-full"
                src="../assets/life.webp"
                alt="Noimage"
              />
            </div>
          </div>
        </div>
      </div>

      <div className="shadow-lg rounded-lg p-4 md:p-8 lg:p-12 mb-6 px-6 mx-4 md:mx-8 lg:mx-10 text-gray-600 flex justify-center items-center">
        <p className="text-lg md:text-base lg:text-lg text-center">
          Choose from a variety of coverage options to tailor your car insurance
          plan to your specific needs. Protect yourself from third-party
          liabilities if you cause an accident, or safeguard your own vehicle
          against damage from collisions, theft, or natural disasters. Compare
          plans, understand coverage details, and get free quotes – all in one
          place. We'll help you find the perfect car insurance plan to ensure a
          smooth ride ahead.{" "}
        </p>
      </div>
   
      <div className="container mx-auto">
      <div className="flex flex-col lg:flex-row">
        {/* Main content area with insurance listings */}
        <div className="w-full lg:w-3/4">
          <div id="insurance_plans" className="lg:pr-6 md:px-4 px-2">
            {loading ? (
              <div className="text-center py-10">Loading insurance options...</div>
            ) : error ? (
              <div className="text-center py-10 text-red-600">{error}</div>
            ) : insuranceData.length === 0 ? (
              <div className="text-center py-10">
                No car insurance options available at the moment.
              </div>
            ) : (
          insuranceData.map((insurance) => (
            <div
              key={insurance.id}
              className="md:w-full max-w-[900px] py-2 border shadow-lg overflow-hidden hover:shadow-xl rounded-lg flex flex-wrap md:flex-nowrap gap-5 justify-between mx-auto mt-4"
            >
              <div className="flex flex-wrap md:flex-nowrap w-full justify-center items-center md:justify-normal">
                <Link to={`/termlife_insurance/${insurance.page_url}`}>
                  <div className="w-[95%] md:w-[220px] overflow-hidden py-2 md:ml-2">
                    <img
                      className="w-full h-full object-contain"
                      alt={insurance.page_title || "Insurance Provider"}
                      src={insurance.image}
                    />
                  </div>
                </Link>
              </div>

              <div className="w-full md:pl-0 pl-4 mt-2 md:mt-6">
                <p className="text-gray-500 font-medium text-sm md:text-base">Premium Starting </p>
                <h4 className="text-xl md:text-2xl py-0.5 font-bold">
                  ₹{insurance.premium_start}
                </h4>
              </div>

              <div className="w-full md:pl-0 pl-4 mt-2 md:mt-6">
                <p className="text-gray-500 font-medium text-sm md:text-base">Claim settlement </p>
                <h4 className="text-xl md:text-2xl py-0.5 font-bold">
                  {insurance.claim_settlement}%
                </h4>
              </div>

              <div className="w-full md:pl-0 pl-4 mt-2 md:mt-6">
                <p className="text-gray-500 font-medium text-sm md:text-base">Life Cover </p>
                <h4 className="text-xl md:text-2xl py-0.5 font-bold">
                  {insurance.network_garages}+
                </h4>
              </div>

              <div className="flex flex-wrap justify-center md:justify-between items-center my-5 w-full gap-2 px-4">
                <a
                  href={insurance.bank_link}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <button className="bg-green-500 text-white font-semibold py-2 px-4 rounded hover:bg-green-600 transition duration-300">
                    Get Quote!
                  </button>
                </a>

                <Link to={`/termlife_insurance/${insurance.page_url}`}>
                  <button className="text-white font-semibold py-2 px-4 rounded hover:bg-blue-600 transition duration-300 bg-blue-500">
                  See Details
                  </button>
                </Link>
              </div>
            </div>
          ))
        )}
      </div>
</div>
<div className="w-full lg:w-1/4 px-2 md:px-4 mt-6 lg:mt-0">
          <div className="sticky top-20">
            {/* Ad 1 - Visible on all screen sizes */}
            <a href="https://play.google.com/store/apps/details?id=com.myairtelapp&pcampaignid=web_share" target="_blank" rel="noopener noreferrer" className="block">
              <img 
                src="/assets/sidebanner.png" 
                alt="Insurance Special Offer" 
                className="w-full rounded-lg shadow-md hover:shadow-lg transition-shadow duration-300"
              />
            </a>
            
            {/* Ad 2 - Hidden on small mobile, visible on larger screens */}
            {/* <a href="https://example.com/premium-discount" target="_blank" rel="noopener noreferrer" className="hidden sm:block mt-6">
              <img 
                src="/assets/niyoo.png" 
                alt="Premium Discount Offer" 
                className="w-full rounded-lg shadow-md hover:shadow-lg transition-shadow duration-300"
              />
            </a> */}
            
            {/* Compact ad for mobile only */}
            {/* <a href="https://example.com/mobile-offer" target="_blank" rel="noopener noreferrer" className="block sm:hidden mt-4">
              <img 
                src="/assets/niyoo.png" 
                alt="Mobile Special Offer" 
                className="w-full rounded-lg shadow-md hover:shadow-lg transition-shadow duration-300"
              />
            </a> */}
          </div>
        </div>
      </div>
    </div>
    <section className="bg-blue-50 py-16 px-6 sm:px-12 lg:px-20 rounded-3xl shadow-lg max-w-7xl mx-auto mt-10">
  <div className="flex flex-col md:flex-row justify-between items-center gap-10">
    {/* Left - Text and CTA */}
    <div className="max-w-xl space-y-6 text-center md:text-left">
      <h2 className="text-2xl sm:text-3xl font-bold text-blue-900 leading-tight">
        Calculate Your Term Life Insurance <br />
        in <span className="text-blue-600">Seconds</span>
      </h2>
      <p className="text-gray-700 text-lg">
        Use our fast and free calculator to estimate your premium — no paperwork, no waiting.
      </p>
      <Link
        to="/financial-tools-calculators/term-insurance-calculator"
        className="inline-flex items-center gap-2 bg-blue-600 hover:bg-blue-700 text-white px-6 py-3 text-lg rounded-full shadow-md transition"
      >
        Start Calculating <ArrowRight className="w-5 h-5" />
      </Link>
    </div>

    {/* Right - Feature List with Emojis */}
    <div className="space-y-4 text-left">
      <div className="flex items-center gap-3">
        <span className="text-xl">🛡️</span>
        <span className="text-gray-800 font-medium">Reliable & Accurate Estimates</span>
      </div>
      <div className="flex items-center gap-3">
        <span className="text-xl">⏱️</span>
        <span className="text-gray-800 font-medium">Takes Less Than a Minute</span>
      </div>
    </div>
  </div>
</section>
      <div className="flex justify-center items-center  p-4 mt-6">
        <div className="bg-white shadow-lg rounded-2xl p-6 max-w-7xl text-center ">
          <h2 className="text-2xl md:text-3xl font-bold text-gray-800 mb-4">
            What is Term Life Insurance?
          </h2>
          <p className="text-gray-600 leading-relaxed">
            Term life insurance is a pure protection plan that provides
            financial security to the policyholder’s family in case of an
            untimely demise during the policy term. It offers high coverage at
            affordable premiums, ensuring that beneficiaries receive a lump sum
            payout (death benefit) if the insured person passes away within the
            policy period. Unlike traditional life insurance plans, it has no
            maturity benefits, making it a cost-effective choice. With flexible
            policy terms, tax benefits under Section 80C and 10(10D), and
            optional riders like critical illness cover or accidental death
            benefits, term insurance serves as an essential financial safety
            net. It helps cover outstanding debts, replaces lost income, and
            secures the future of dependents, giving policyholders peace of
            mind.
          </p>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 py-6 text-center">
        <h2 className="text-2xl md:text-3xl font-semibold text-gray-800">
          Statistics
        </h2>
        {/* <p className="text-gray-600 text-sm md:text-base mt-2">
        Choosing the right car insurance is crucial for financial security on the road. 
        Here are the three main types of car insurance plans:
      </p> */}

        <div className="mt-6 grid md:grid-cols-3 gap-6 text-left">
          <div className="p-6 border rounded-lg shadow-md bg-white">
            <span className="text-3xl">📉</span>
            <h3 className="text-lg font-semibold text-gray-800 mt-2">
              Insurance Penetration
            </h3>
            <p className="text-gray-700 text-sm mt-1">
              As of recent reports, life insurance penetration in India stands
              at around 3.2% of GDP, with term insurance making up a smaller
              fraction due to low awareness and preference for traditional
              savings-linked policies.
            </p>
          </div>

          <div className="p-6 border rounded-lg shadow-md bg-white">
            <span className="text-3xl">🛡</span>
            <h3 className="text-lg font-semibold text-gray-800 mt-2">
              Protection Gap
            </h3>
            <p className="text-gray-700 text-sm mt-1">
              India has a huge protection gap of nearly 83%, meaning most
              individuals are underinsured or lack adequate life cover, putting
              their families at financial risk in case of an untimely demise.
            </p>
          </div>

          <div className="p-6 border rounded-lg shadow-md bg-white">
            <span className="text-3xl">💵</span>
            <h3 className="text-lg font-semibold text-gray-800 mt-2">
              Affordable Premiums
            </h3>
            <p className="text-gray-700 text-sm mt-1">
              Term insurance offers high coverage at low cost, with a ₹1 crore
              term insurance policy available for as little as ₹500-800 per
              month for a young and healthy individual, making it one of the
              most cost-effective ways to secure a family’s future.
            </p>
          </div>
        </div>
      </div>

      <div className="p-8 max-w-7xl mx-auto ">
        {/* Header */}
        <h2 className="text-2xl md:text-3xl font-bold text-center text-gray-900 mb-6">
          Types of Term Life Insurance
        </h2>
        {/* <p className="text-lg text-center text-gray-600 mb-10">
        Choosing the right health insurance plan ensures financial security and access to quality healthcare.
      </p> */}

        {/* Insurance Cards */}
        <div className="grid md:grid-cols-3 sm:grid-cols-2 gap-8">
          {TerminsuranceTypes.map((insurance, index) => (
            <div
              key={index}
              className="bg-white p-6 rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 transform hover:scale-105 text-center"
            >
              <div className="flex justify-center mb-4">{insurance.icon}</div>
              <h3 className="text-xl font-semibold text-gray-900 mb-2">
                {insurance.title}
              </h3>
              <p className="text-gray-600">{insurance.description}</p>
            </div>
          ))}
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 py-6">
        <h2 className="text-2xl md:text-3xl font-bold text-center text-gray-800 mb-6">
          Why Do We Need Term Life Insurance?
        </h2>
        <div className="grid md:grid-cols-2 gap-6">
          {reasons.map((reason, index) => (
            <div
              key={index}
              className="flex items-start gap-4 p-4 border border-gray-200 rounded-lg shadow-sm hover:shadow-md transition"
            >
              <div>{reason.icon}</div>
              <div>
                <h3 className="text-lg font-semibold text-gray-800">
                  {reason.title}
                </h3>
                <p className="text-gray-600">{reason.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
      <div className="max-w-7xl mx-auto px-4 py-6">
        <h2 className="text-2xl md:text-3xl font-bold text-center text-gray-800 mb-6">
          Coverage Under Term Life Insurance
        </h2>
        <div className="grid md:grid-cols-2 gap-6">
          {coverageOptions.map((item, index) => (
            <div
              key={index}
              className="flex items-start gap-4 p-4 border border-gray-200 rounded-lg shadow-sm hover:shadow-md transition"
            >
              <div>{item.icon}</div>
              <div>
                <h3 className="text-lg font-semibold text-gray-800">
                  {item.title}
                </h3>
                <p className="text-gray-600">{item.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
      <div className="w-full flex justify-center items-center my-6 px-4">
          <a
            href={ad2.link}
            target="_blank"
            rel="noopener noreferrer"
            className="w-full max-w-[984px]"
          >
            <img
              src={ad2.image}
              alt={ad2.altText}
              className="w-full h-auto object-contain rounded-lg shadow-md transition duration-300 hover:scale-105"
              style={{ aspectRatio: "984 / 410" }}
            />
          </a>
        </div>
      <div className=" px-2 md:px-6 bg-gray-100">
        <div className=" p-6 min-h-screen">
          <h1 className="text-2xl md:text-3xl font-bold text-blue-700 mb-4">
            Exclusions Under Term Life Insurance{" "}
          </h1>
          {/* <p className="text-gray-700 mb-6">
            The cost of your bike insurance is influenced by several crucial factors. Understanding these can help you choose the right policy while optimizing your premium costs.  </p> */}

          {points3.map((point, index) => (
            <div
              key={index}
              className="mb-4 p-4 bg-white rounded-lg shadow-md border-l-4 border-blue-500"
            >
              <h2 className="text-xl font-semibold text-blue-600">
                {point.title}
              </h2>
              <p className="text-gray-600">{point.description}</p>
            </div>
          ))}
        </div>
      </div>
      <div className=" px-2 md:px-6 bg-gray-100">
        <div className=" p-6 min-h-screen">
          <h1 className="text-2xl md:text-3xl font-bold text-blue-700 mb-4">
            Things to Consider While Taking Term Life Insurance{" "}
          </h1>
          {/* <p className="text-gray-700 mb-6">
            The cost of your bike insurance is influenced by several crucial factors. Understanding these can help you choose the right policy while optimizing your premium costs.  </p> */}

          {points2.map((point, index) => (
            <div
              key={index}
              className="mb-4 p-4 bg-white rounded-lg shadow-md border-l-4 border-blue-500"
            >
              <h2 className="text-xl font-semibold text-blue-600">
                {point.title}
              </h2>
              <p className="text-gray-600">{point.description}</p>
            </div>
          ))}
        </div>
      </div>
      <div className=" px-2 md:px-6 bg-gray-100">
        <div className=" p-6 min-h-screen">
          <h1 className="text-2xl md:text-3xl font-bold text-blue-700 mb-4">
            Factors Affecting Term Life Insurance
          </h1>
          <p className="text-gray-700 mb-6">
            The cost of your bike insurance is influenced by several crucial
            factors. Understanding these can help you choose the right policy
            while optimizing your premium costs.{" "}
          </p>

          {points1.map((point, index) => (
            <div
              key={index}
              className="mb-4 p-4 bg-white rounded-lg shadow-md border-l-4 border-blue-500"
            >
              <h2 className="text-xl font-semibold text-blue-600">
                {point.title}
              </h2>
              <p className="text-gray-600">{point.description}</p>
            </div>
          ))}
        </div>
      </div>
      {/* FAQ section */}
      <div className="max-w-4xl mx-auto py-6 px-2">
        <h1 className="text-2xl md:text-3xl font-semibold text-center mb-8">
          Frequently Asked Questions
        </h1>
        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="border rounded-lg overflow-hidden shadow-md"
            >
              <button
                onClick={() => toggleAccordion(index)}
                className="w-full p-4 text-left text-lg font-semibold focus:outline-none flex justify-between items-center"
              >
                {faq.question}
                <Icon id={index} open={activeIndex} />
              </button>
              {activeIndex === index && (
                <div className="p-4 bg-gray-100">
                  <p className="text-gray-700">{faq.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default TermLifeInsuranceNew;
